"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = require("lodash");
var React = __importStar(require("react"));
var App_1 = __importDefault(require("../App/App"));
var enums_1 = require("../Common/utils/enums");
var VerifyAccount_1 = require("../VerifyAccount");
var SecondCardChallenge_1 = __importDefault(require("../VerifyPaymentCard/SecondCardChallenge/SecondCardChallenge"));
var ChallengeResolver = function (props) {
    var state = React.useContext(App_1["default"]).state;
    // Do not render challenge without a callback registered
    // once the challenge has been set.
    if (!lodash_1.isNil(state.challenge) && lodash_1.isNil(state.onSuccess)) {
        // tslint:disable-next-line:no-console
        console.warn('Missing callback registry');
        return null;
    }
    switch (state.challenge) {
        case enums_1.RiskActions.PhoneEmailVerify:
            return React.createElement(VerifyAccount_1.PhoneEmailVerification, __assign({}, props));
        case enums_1.RiskActions.PaymentCardNotVerified:
            return React.createElement(SecondCardChallenge_1["default"], __assign({}, props));
        case enums_1.RiskActions.VerificationRequired:
            return React.createElement(VerifyAccount_1.TwoFactorAuthentication, __assign({}, props));
        default:
            return null;
    }
};
exports["default"] = ChallengeResolver;
